var map = {
	"./de/mechaName.png": "+PYL",
	"./en/mechaName.png": "I1KQ",
	"./es/mechaName.png": "THBW",
	"./fr/mechaName.png": "Qrz/",
	"./ja/mechaName.png": "dBq3",
	"./ko/mechaName.png": "i8i+",
	"./pt/mechaName.png": "7F49",
	"./ru/mechaName.png": "O66v",
	"./tc/mechaName.png": "1hLL",
	"./th/mechaName.png": "C7/j"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CL4O";